import { toCartImpressionTrackingInfo } from "@omni/services/tracking/mappers/cart.mapper";
import { getOrderDetailsImpressionTrackingInfo } from "@omni/services/tracking/mappers/order.mapper";
import {
    TOOL_CHECKOUT_CONTEXT,
    TOOL_CHECKOUT_STEPS
} from "@omni/services/tracking/trackers/tools/checkout/config";
import * as ToolsStepTracker from "@omni/services/tracking/trackers/tools/toolStep.tracker";
import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { OrderDetail } from "@omni/types/api/cart/bff/orderDetail.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";
import { capitalize } from "lodash-es";

import { createUserId } from "../../utils";

export const trackCartStart = (cart: Cart) => {
    ToolsStepTracker.track(
        TOOL_CHECKOUT_STEPS.cartStep,
        TOOL_CHECKOUT_CONTEXT,
        { cart: toCartImpressionTrackingInfo(cart) }
    );
};

export const trackLoginStart = (cart: Cart) => {
    ToolsStepTracker.track(
        TOOL_CHECKOUT_STEPS.loginStep,
        TOOL_CHECKOUT_CONTEXT,
        { cart: toCartImpressionTrackingInfo(cart) }
    );
};

export const trackUserInfoStart = (
    cart: Cart,
    customerid?: string | undefined
) => {
    ToolsStepTracker.track(
        {
            ...TOOL_CHECKOUT_STEPS.userInfoStep,
            result: { customerid }
        },
        TOOL_CHECKOUT_CONTEXT,
        { cart: toCartImpressionTrackingInfo(cart) }
    );
};

export const trackPaymentStart = (
    cart: Cart,
    customerid?: string | undefined
) => {
    ToolsStepTracker.track(
        {
            ...TOOL_CHECKOUT_STEPS.paymentStep,
            result: { customerid }
        },
        TOOL_CHECKOUT_CONTEXT,
        { cart: toCartImpressionTrackingInfo(cart) }
    );
};

export const trackConfimationSubmit = (order: OrderDetail) => {
    const deliveryMethods: Array<DeliveryType> = [];

    if (
        order.items.some((i) => i.deliveryType === DeliveryType.ClickAndCollect)
    ) {
        deliveryMethods.push(DeliveryType.ClickAndCollect);
    }

    if (order.items.some((i) => i.deliveryType === DeliveryType.HomeDelivery)) {
        deliveryMethods.push(DeliveryType.HomeDelivery);
    }

    const step: StepVariables = {
        ...TOOL_CHECKOUT_STEPS.confirmationStep,
        result: {
            customerid: createUserId(order.customer.email),
            deliverymethod: deliveryMethods.join(",")
        }
    };

    const customerName = `${order.customer.firstName} ${order.customer.lastName}`;

    const cart = getOrderDetailsImpressionTrackingInfo({
        order: order,
        name: customerName
    });

    const mainPayment = order.payments.at(0);
    const paymentMethod = capitalize(
        mainPayment?.issuer || mainPayment?.paymentMethodCode
    );

    ToolsStepTracker.trackSubmit(step, TOOL_CHECKOUT_CONTEXT, {
        cart: cart,
        option: paymentMethod
    });
};
